import { Component, Input } from '@angular/core';
import { MultiLinkAccordion } from '@app/models/elements/multi-link-accordion';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';

@Component({
	selector: 'app-multi-link-accordion',
	standalone: true,
	imports: [LoadingSpinnerComponent],
	templateUrl: './multi-link-accordion.component.html',
	styleUrl: './multi-link-accordion.component.css',
})
export class MultiLinkAccordionComponent {
	@Input() accordion: MultiLinkAccordion = {} as MultiLinkAccordion;
}
